/**
 * Cashback-specific form data builders.
 *
 * Builds guardrails and attributes for CASHBACK campaign type
 * from form state. Extracted from formDataBuilder for single-responsibility.
 *
 * @module cashbackDataBuilder
 */

import {
    CurrencyCode,
    RoundingOption,
} from 'src/@types/valueMatching/enums';
import { CashbackGuardrail } from 'src/@types/valueMatching/guardrails';
import { CashbackAttributes } from 'src/@types/valueMatching/attributes';
import { UseCampaignFormResult } from 'src/hooks/useCampaignForm/useCampaignForm';
import { parseOptionalNumber } from 'src/utils/helpers';

// ============================================================================
// Public API
// ============================================================================

/** Builds Cashback guardrail from form state. */
export function buildCashbackGuardrail(form: UseCampaignFormResult): CashbackGuardrail {
    const guardrail: CashbackGuardrail = {
        percentExtentOfCompetitorGuardrail: parseOptionalNumber(form.cashbackExtentGuardrail),
    };

    const percentLimit = parseOptionalNumber(form.cashbackPercentLimitGuardrail);
    if (percentLimit != null) {
        guardrail.percentOfASINPriceGuardrail = percentLimit;
    }

    const absoluteLimit = parseOptionalNumber(form.cashbackAbsoluteLimitGuardrail);
    if (absoluteLimit != null) {
        guardrail.absoluteValueGuardrail = {
            currencyValue: absoluteLimit,
            currencyCode: CurrencyCode.INR,
        };
    }

    return guardrail;
}

/** Builds Cashback attributes from form state. */
export function buildCashbackAttributes(form: UseCampaignFormResult): CashbackAttributes {
    const attrs: CashbackAttributes = {
        primeRestriction: form.primeRestriction,
        termsAndConditions: form.termsAndConditions,
    };

    if (form.roundingOption) {
        attrs.roundToNearest = form.roundingOption as RoundingOption;
    }

    return attrs;
}
